module.exports = __webpack_public_path__ + "assets/img/29_252_big.eba80ccc.jpg";